/**
 * Types and constants for ImageGeneratePanel components (AI Image Generator)
 */

import { ImageGenStatus } from "@optidev/shared-types";

// Constants
const MAX_REFERENCE_IMAGES = 3;

// Aspect ratio options - OptiSigns standard orientations
const ASPECT_RATIOS = [
  { value: "16:9", label: "Landscape (16:9)" },
  { value: "9:16", label: "Portrait (9:16)" },
] as const;

// Style presets for OptiSigns digital signage
const STYLE_PRESETS = [
  { value: "none", label: "No style" },
  { value: "professional", label: "Professional" },
  { value: "modern", label: "Modern & Clean" },
  { value: "bold", label: "Bold & Vibrant" },
  { value: "elegant", label: "Elegant" },
  { value: "minimalist", label: "Minimalist" },
  { value: "photorealistic", label: "Photorealistic" },
  { value: "illustration", label: "Illustration" },
  { value: "3d-render", label: "3D Render" },
  { value: "minimalist", label: "Minimalist" },
  { value: "abstract", label: "Abstract" },
] as const;

// Types
interface GeneratingImage {
  requestId: string;
  status: ImageGenStatus;
  prompt: string;
  filename: string;
  downloadUrl?: string;
  resultFileId?: string;
  errorMessage?: string;
}

// Image generation request from API
interface ImageGenRequestItem {
  id: string;
  status: ImageGenStatus;
  prompt: string;
  expectedFilename: string;
  aspectRatio: string;
  resultFileId?: string;
  downloadUrl?: string;
  assetPath?: string; // Relative path for local assets (e.g., "/assets/image.png")
  errorMessage?: string;
  createdAt: string;
  completedAt?: string;
}

interface ReferenceImage {
  file: File;
  preview: string;
}

interface ImageGeneratePanelProps {
  projectId?: string;
  devContainerId?: string; // For local save mode (skip R2, save directly to dev-container)
  previewUrl?: string; // For generating downloadUrl for local assets
  onBack: () => void;
}

export { MAX_REFERENCE_IMAGES, ASPECT_RATIOS, STYLE_PRESETS };
export type {
  GeneratingImage,
  ImageGenRequestItem,
  ReferenceImage,
  ImageGeneratePanelProps,
};
